import React from 'react';
import { withRouter } from 'react-router-dom';
import { FaSun, FaMoon, FaTv } from 'react-icons/fa';
import { useDisplayMode } from './displayMode';
import { useI18n } from '../i18n';
import './DisplayModeSwitch.css';

const DisplayModeSwitch = ({ showWall = true, history }) => {
    const { t } = useI18n();
    const { theme, viewMode, setTheme, setViewMode } = useDisplayMode();

    const enterWall = () => {
        setViewMode('wall');
        if (history && history.location && history.location.pathname !== '/') {
            history.push('/');
        }
    };

    return (
        <div className="display-switch" role="group" aria-label={t('common.appearance')}>
            <button
                type="button"
                className={`display-switch-btn${theme === 'light' && viewMode !== 'wall' ? ' is-active' : ''}`}
                aria-pressed={theme === 'light' && viewMode !== 'wall'}
                title={t('display.light')}
                onClick={() => setTheme('light')}
            >
                <FaSun aria-hidden="true" />
                <span>{t('display.light')}</span>
            </button>
            <button
                type="button"
                className={`display-switch-btn${theme === 'dark' && viewMode !== 'wall' ? ' is-active' : ''}`}
                aria-pressed={theme === 'dark' && viewMode !== 'wall'}
                title={t('display.dark')}
                onClick={() => setTheme('dark')}
            >
                <FaMoon aria-hidden="true" />
                <span>{t('display.dark')}</span>
            </button>
            {showWall ? (
                <button
                    type="button"
                    className={`display-switch-btn${viewMode === 'wall' ? ' is-active' : ''}`}
                    aria-pressed={viewMode === 'wall'}
                    title={t('display.wallTitle')}
                    onClick={() => (viewMode === 'wall' ? setViewMode('standard') : enterWall())}
                >
                    <FaTv aria-hidden="true" />
                    <span>{t('display.wall')}</span>
                </button>
            ) : null}
        </div>
    );
};

export default withRouter(DisplayModeSwitch);
